// Bag speed chart: filter by brand, expand a row for materials.
// Ordering is fixed - slowest slow-side first, so the bars step across the
// scale from control bags to aggressive ones. Bags without a published speed
// sit at the end. Data lives in assets/ss-speed-data.json.
window.ssSpeed = function (id, dataUrl) {
  const root = document.getElementById('sp-' + id);
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const rowsEl = root.querySelector('[data-sp-rows]');
  const COLOR = { Control: '#0d9488', Balanced: '#f5871f', Aggressive: '#e6392b' };
  const pos = (v) => ((v - 1) / 9) * 100;
  let data = [];
  let brand = 'All';
  let open = null;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function render() {
    const list = data.filter((x) => brand === 'All' || x.b === brand);
    const rated = list.filter((x) => x.f != null)
      .sort((a, b) => a.s - b.s || a.f - b.f || a.n.localeCompare(b.n));
    const rows = rated.concat(list.filter((x) => x.f == null));
    if (!rows.length) {
      rowsEl.innerHTML = '<p class="ss-sp__none">No bags match that filter.</p>';
      return;
    }
    rowsEl.innerHTML = rows.map((x) => {
      const key = x.b + '-' + x.n;
      const isOpen = open === key;
      const ticks = [2, 3, 4, 5, 6, 7, 8, 9]
        .map((n) => `<span class="ss-sp__tick" style="left:${pos(n)}%"></span>`).join('');
      const bar = x.f != null
        ? `<span class="ss-sp__span" style="left:${pos(x.s)}%;width:${pos(x.f) - pos(x.s)}%;background:${COLOR[x.l] || '#6b7078'}"><span>${x.s}</span><span>${x.f}</span></span>`
        : '<span class="ss-sp__tbd">Speed TBD</span>';
      const facts = [];
      if (x.f != null) facts.push(`<li><b>Speed:</b> slow side ${x.s}, fast side ${x.f} &middot; ${esc(x.l)} lean</li>`);
      if (x.sm) facts.push(`<li><b>Slow side:</b> ${esc(x.sm)}</li>`);
      if (x.fn) facts.push(`<li><b>Fast side:</b> ${esc(x.fn)}</li>`);
      if (!facts.length) facts.push('<li>Speed data coming soon for this bag.</li>');
      const panel = isOpen ? `<div class="ss-sp__more"><div class="ss-sp__card"><ul>${facts.join('')}</ul>`
        + '<div class="ss-sp__links"><a class="p" href="/collections/cornhole-bags">Shop bags &rarr;</a>'
        + '<a class="g" href="/blogs/learn/the-only-roll-bag-tutorial-you-need">How to throw it &rarr;</a></div></div></div>' : '';
      return `<div class="ss-sp__row">`
        + `<button class="ss-sp__hit" type="button" aria-expanded="${isOpen}" data-sp-key="${esc(key)}">`
        + `<span class="ss-sp__name"><b>${esc(x.n)}</b><span>${esc(x.b)}${x.l ? ' &middot; ' + esc(x.l) : ''}</span></span>`
        + `<span class="ss-sp__track">${ticks}${bar}</span>`
        + `<span class="ss-sp__caret" aria-hidden="true">&#9662;</span>`
        + `</button>${panel}</div>`;
    }).join('');
  }

  rowsEl.addEventListener('click', (e) => {
    const hit = e.target.closest('[data-sp-key]');
    if (!hit) return;
    open = open === hit.dataset.spKey ? null : hit.dataset.spKey;
    render();
  });
  root.querySelectorAll('[data-sp-brand]').forEach((btn) => {
    btn.addEventListener('click', () => {
      brand = btn.dataset.spBrand;
      open = null;
      root.querySelectorAll('[data-sp-brand]').forEach((o) => o.setAttribute('aria-pressed', String(o === btn)));
      render();
    });
  });

  fetch(dataUrl)
    .then((r) => r.json())
    .then((d) => { data = d; render(); })
    .catch(() => { rowsEl.innerHTML = '<p class="ss-sp__none">Speed data could not be loaded.</p>'; });
};
